/**
 * Types and utility functions for case studies
 */
import { IGatsbyImageData } from 'gatsby-plugin-image';

export interface FeatureQuote {
  quote: string;
  author: string;
  position?: string;
}

export interface CaseStudy {
  id: string;
  slug: string;
  title: string;
  school: string;
  location: string;
  state: string;
  students: string;
  setting: string;
  englishLanguageLearners: string;
  description: string;
  image: string;
  video?: string;
  mp4?: string;
  youtube?: string;
  featureQuote?: FeatureQuote;
  fullCaseStudy: string;
}

export interface CaseStudyWithImageData extends CaseStudy {
  imageData: IGatsbyImageData;
}

export interface CaseStudyStat {
  /**
   * `sector` is currently a copy of the `ell` artwork, kept separate so either
   * can change without affecting the other.
   */
  icon: 'location' | 'students' | 'setting' | 'ell' | 'calendar' | 'sector';
  label: string;
  value: string;
}

/**
 * Minimal, locale-neutral shape consumed by the list/tile components.
 * CaseStudyWithImageData satisfies it structurally; locale-specific data
 * files can provide `subtitle` directly instead of a `state` field.
 */
export interface CaseStudyListItem {
  id: string;
  slug: string;
  title: string;
  school: string;
  state?: string;
  subtitle?: string;
  description: string;
  imageData: IGatsbyImageData;
}

export interface CaseStudyDetailData extends CaseStudyListItem {
  location?: string;
  students?: string;
  setting?: string;
  englishLanguageLearners?: string;
  video?: string;
  youtube?: string;
  featureQuote?: FeatureQuote;
  fullCaseStudy: string;
}

export function caseStudySubtitle(study: CaseStudyListItem): string {
  return study.subtitle ?? (study.state ? `${study.school}, ${study.state}` : study.school);
}
